/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import { TableCell, ParagraphWithTooltip, CustomTooltip } from 'components';

const columnsWithRightBorder = ['bid', 'budget'];

const checkLocalStorage = (props) => {
  const sortingState = JSON.parse(
    localStorage.getItem('sortTable') ?? JSON.stringify({ direction: '', column: '' }),
  );
  if (sortingState.column === props.column.colId) {
    props.column.setSort(sortingState.direction);
    props.api.onSortChanged();
    return sortingState.direction;
  }

  return null;
};

const isEventHeader = (colId) => {
  return colId.includes('event');
};

const chooseWidth = (columnApi) => {
  if (!columnApi.colId.includes('event')) {
    return '100%';
  } else {
    // 12 = 8 + 4 - icon size; 8 = 4x2 - cell padding; 4 - extra space to compensate transform
    return `${columnApi.actualWidth - 12 - 8 - 4}px`;
  }
};

export const CustomTableHeader = (props) => {
  const [sortState, setSortState] = useState(null); // 'asc', 'desc', или null
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useLayoutEffect(() => {
    checkLocalStorage(props);
  }, [props.column.colId]);

  useEffect(() => {
    const onSortChanged = () => {
      if (props.column.isSortAscending()) {
        setSortState('asc');
      } else if (props.column.isSortDescending()) {
        setSortState('desc');
      } else {
        setSortState(null);
      }
    };
    onSortChanged();
    props.column.addEventListener('sortChanged', onSortChanged);
    return () => {
      props.column.removeEventListener('sortChanged', onSortChanged);
    };
  }, [props.column]);

  const handleSort = () => {
    let newSort;
    if (sortState === 'asc') {
      newSort = 'desc';
    } else {
      newSort = 'asc';
    }

    props.api.getAllGridColumns().forEach((col) => {
      if (col !== props.column) {
        col.setSort(null);
      }
    });
    localStorage.setItem(
      'sortTable',
      JSON.stringify({ direction: newSort, column: props.column.colId }),
    );
    props.column.setSort(newSort);
    props.api.onSortChanged();
  };

  const tooltip = useMemo(() => {
    const tooltipObj = {
      isTooltip: false,
      message: '',
      styles: {},
    };

    switch (props.column.colId) {
      case 'countries':
        tooltipObj.isTooltip = true;
        tooltipObj.message =
          'Only Targeted (Without excluded) Countries without regions and cities';
        break;
    }

    return tooltipObj;
  }, [props.column.colId]);

  const isEvent = isEventHeader(props.column.colId);

  if (props.column.colId === 'action') return null;

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
      onMouseOver={tooltip.isTooltip ? () => setIsTooltipOpen(true) : () => {}}
      onMouseLeave={tooltip.isTooltip ? () => setIsTooltipOpen(false) : () => {}}
    >
      <TableCell.Component
        size={TableCell.sizes[64]}
        onClick={handleSort}
        direction={sortingNames[sortState]}
        style={{
          justifyContent: props.displayName == 'Campaign' ? 'start' : 'center',
          paddingLeft: props.displayName == 'Campaign' ? '40px' : '4px',
          background: 'transparent',
          borderLeft: isEvent ? '1px solid #e2e8f0' : 'none',
          borderRight: columnsWithRightBorder.includes(props.column.colId)
            ? '1px solid #e2e8f0'
            : 'none',
          width:
            props.column.colId === 'countries'
              ? '64px'
              : props.column.colId === 'impressions'
              ? '70px'
              : '',
        }}
      >
        <div
          style={{
            maxWidth: chooseWidth(props.column),
            width: isEvent ? 'auto' : chooseWidth(props.column),
          }}
        >
          <ParagraphWithTooltip
            text={props.displayName}
            style={{ whiteSpace: !isEvent ? 'break-spaces' : 'unset' }}
          />
        </div>
        {tooltip.isTooltip && isTooltipOpen && (
          <CustomTooltip
            style={{
              position: 'absolute',
              justifyContent: 'flex-start',
              maxWidth: '275px',
              pointerEvents: 'none',
              top: '4px',
              left: '50%',
            }}
            text={
              <p style={{ width: '160px', margin: '4px 0', ...tooltip.styles }}>
                {tooltip.message}
              </p>
            }
            isOpen={true}
          />
        )}
      </TableCell.Component>
    </div>
  );
};

const sortingNames = {
  asc: 'ascending',
  desc: 'descending',
};
